<template>
  <div class="modal-column">
    <div class="px-16px py-8px ">
      <!-- 9985 -->
      <Button @click="doAuto">智能匹配往来单位</Button>
    </div>
    <div class="modal-column-full-body">
      <div style="display: flex;flex-direction: column; color: red;padding-bottom: 16px;">
        <span>{{hint1}}</span>
        <span>{{hint2}}</span>
        <span>{{hint3}}</span>
      </div>
      <div class="flex mb-16px" v-for="(r,index) in records">
        <div class="border w-300px">
          <div class="p-8px bg-gray3-color">{{ r.customerName }}：{{ r.invoiceNumber || r.invoiceCode || r.electricInvoiceCode }}</div>
          <div class="p-8px">
            <div>开票日期：{{ r.tradeDate }}</div>
            <div class="my-8px">业务类型：{{ r.businessType }}</div>
            <div class="my-8px"> 金额：{{ r.taxAmountExcluded }}</div>
            <div> 税额：{{ r.taxAmount }}</div>
          </div>
        </div>
        <div class="flex-1 ml-16px border">
          <template v-if="r.voucher">
            <div class="p-8px bg-gray3-color" style="display: flex;justify-content: space-between;">
              <div>
                <span class="mr-26px">日期：{{ r.voucher.voucherDate }}</span> 
                <span>凭证字号：{{
                  r.voucher.word
                  }}-{{ r.voucher.code }}
                </span>
              </div>
              <div>
                <span class="span fa fa-reply mr-6px point-jxd" @click="edit(index)">修改</span>
                <span class="span fa fa-remove point-jxd" @click="removeRow(index)">移除</span>
              </div>
            </div>
            <div class="p-8px">
              <vxe-table :data="r.voucher.details" :show-overflow="false" :show-header="false" show-footer
                         :footer-method="footerMt">
                <vxe-column field="summary"/>
                <vxe-column field="subjectName">
                  <!-- 9985 -->
                  <template #default="{row}">
                    <block v-if="row.auxiliary && row.auxiliary.length > 0 && row.auxiliaryAccounting">
                      <div v-if="row.auxiliary.length !== row.auxiliaryAccounting.length" style="color: red">{{ row.subjectName }}</div>
                      <div v-else="row.auxiliary.length == row.auxiliaryAccounting.length" style="color: black">{{ row.subjectName }}</div>
                    </block>
                    <block v-else>
                      <div v-if="msgSubjectIdList.includes(row.subjectId)" style="color: red">{{ row.subjectName }}</div>
                      <div v-else="msgSubjectIdList.includes(row.subjectId)" style="color: black">{{ row.subjectName }}</div>
                    </block>
                  </template>
                </vxe-column>
                <vxe-column field="debitAmount" align="right" width="120" formatter="toMoney"/>
                <vxe-column field="creditAmount" align="right" width="120" formatter="toMoney"/>
              </vxe-table>
            </div>
          </template>
          <template v-else>
            请先设置凭证模板
          </template>
        </div>
      </div>
    </div>
    <div class="modal-column-between">
      <vxe-button :loading="loading" @click="$emit('close')" icon="fa fa-close">取消</vxe-button>
      <vxe-button :loading="loading" @click="doSubmit()" status="primary" icon="fa fa-check">生 成</vxe-button>
    </div>
  </div>
</template>

<script>
import {Invoice, InvoiceBusiness} from "@/api/Invoice";
import voucher from "@/api/voucher";
import {mapGetters, mapState} from "vuex";
import manba from "manba";
import setting from "@/api/setting";
import {confirm, message} from "heyui.ext";
import {layer} from "@layui/layer-vue";
import { h } from "vue";
import VoucherForm from "@/views/voucher/VoucherForm.vue";

/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "InvoiceGenerateVoucher",
  props: {
    records: Array,
    type: String,
    dateModel: String,
  },
  data() {
    return {
      subjectNameList: [],
      msgSubjectNameList: [],
      msgSubjectIdList:[],
      //jxd 3个提示语
      hint1: '',
      hint2: '',
      hint3: '',
      loading: false,
      templateMap: {},
      subjectList: [],//9985
      accountingCategoryDetailsList:[],//9985
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['localCurrency']),
    accountDate() {
      return manba(this.currentAccountSets.currentAccountDate).endOf(manba.MONTH).format();
    }
  },
  methods: {
    //9985
   loadAccountingCategory(){
      setting.accountingCategory.list().then(({data}) => {
        const categorys = (data || []).filter(val => ['客户','供应商'].includes(val.name));
        if (categorys.length) {
          setting.accountingCategoryDetails.loadAuxiliaryAccountingData(categorys).then(({data}) => {
            console.log(data,"8888888888888")
            this.accountingCategoryDetailsList = data;
          })
        }
      })
    },
    doAuto() {
      this.$Confirm("智能匹配往来单位：当科目是辅助核算/非明细科目的时候，会根据发票中的客户/供应商名称匹配辅助核算名称/明细科目名称，如未找到仍需手工选择").then(() => {
        this.records.forEach((record, index) => {
          record.voucher.details.forEach(detail => {
            //进入凭证明细
            let foundId = this.subjectList.find(subject => subject.id === detail.subjectId);  //9985
            console.log(foundId)
            if(foundId.enableAuxiliary || foundId.auxiliaryAccounting.length > 0){
              detail.auxiliary = []
              detail.auxiliaryAccounting = foundId.auxiliaryAccounting
              console.log("是核算",record.type)
              //是辅助核算科目 看是不是应收应付，其他应收应付
              foundId.auxiliaryAccounting.forEach(auxiliary => {
                //科目核算的是不是客户供应商
                if(auxiliary === "0" && record.type == "OUT"){
                  //客户并且发票是销项
                  console.log("out",record.customerName,this.accountingCategoryDetailsList)
                  this.accountingCategoryDetailsList[0].forEach((item)=>{
                    console.log(item)
                    if(item.categoryId == 0 && item.name.trim() == record.customerName.trim()){
                      console.log("找到了")
                      //找到和辅助核算相同名称的客户
                      detail.auxiliary.push(item)
                    }
                  })
                }else if(auxiliary === "1" && record.type == "IN"){
                  //供应商并且发票是进项
                  console.log("in")
                  this.accountingCategoryDetailsList[1].forEach((item)=>{
                    console.log(item)
                    if(item.categoryId == 1 && item.name.trim() == record.customerName.trim()){
                      console.log("找到了")
                      //找到和辅助核算相同名称的供应商
                      detail.auxiliary.push(item)
                    }
                  })
                }
              })
            }else if(!foundId.leaf){
              //非明细科目 看子科目是不是有和客户，供应商同名的
              console.log("我是不是明细",record,this.subjectList)
              this.subjectList.forEach(subject => {
                if(subject.parentId === foundId.id && subject.leaf && record.customerName.trim() == subject.name.trim()){
                  console.log(subject,"999999999999999999999999999")
                  //找到了一致的
                  detail.subjectId = subject.id;
                  detail.subjectName = subject.fullName;
                  if(subject.currencyAccounting.length > 0 || !subject.enableForCurrency){
                    //不是外币
                    console.log("我执行了吗吗",subject.currencyAccounting[0])
                    detail.currencyId = subject.currencyAccounting[0];
                  }else{
                    detail.currencyId = detail.currencyId;
                  }
                }
              })
            }
          })
        })
        console.log(this.records)
        this.checkSubject();//检测依稀
      })
    },  
    //jxd编辑
    edit(index){
      let editCashierVoucherData = JSON.parse(JSON.stringify(this.records[index].voucher)); 
      // // console.log(data)
      editCashierVoucherData.details.forEach(val => {

        let foundSubject = this.subjectNameList.find(subject => subject.id === val.subjectId);
        val.subject = foundSubject;
        val.balanceDirection = foundSubject.balanceDirection;
          val.debitAmount = val.debitAmount ? val.debitAmount : 0;
          val.creditAmount = val.creditAmount ? val.creditAmount : 0 ;
          val.isCarry = true;
          val.originalCreditAmount = val.creditAmount;
          val.originalDebitAmount = val.debitAmount;
          val.subjectType = foundSubject.type;
          val.incOrcash = true;//给src\components\VoucherTable\VTableSubject.vueconst loadCurrency 做判断用
      })
      let layerId = layer.drawer({
        title: "发票生成凭证",
        shadeClose: false,
        zIndex: 999,
        area: ['1100px', '100vh'],
        content: h(VoucherForm, {
          editIncVoucher:true,
          editIncVoucherData: editCashierVoucherData,
          onSuccess: (data) => {
            // loadList();
            let array = JSON.parse(data)
            console.log("wwww",array)
            array.forEach(val => {
              val.subjectName = val.subject.code + '-' + val.subject.fullName;
            })
            // voucherList.value[id].details = array;
            this.records[index].voucher.details = array;
            this.records[index].voucher.creditAmount = this.records[index].voucher.details.reduce((sum, val) => {
              return sum + (val.creditAmount || 0); // 累加器加上当前值的 creditAmount
            }, 0); // 初始值设为 0
            console.log(this.records[index].creditAmount)
            this.records[index].voucher.debitAmount = this.records[index].voucher.details.reduce((sum, val) => {
              return sum + (val.debitAmount || 0); // 累加器加上当前值的 creditAmount
            }, 0); // 初始值设为 0
            console.log(this.records[index].debitAmount)
            this.checkSubject();
            // console.log(voucherList.value)
            layer.close(layerId);
          },
          onClose: () => {
            // loadList();
            layer.close(layerId);
          }
        })
      })
    },
    //jxd科目检测
    checkSubject(){
      // console.log('检测科目',voucherList.value)
      setting.subject.listAll().then(({data}) => {
        // subjectList.value = data;  
        this.subjectList = data;  //9985
        this.subjectNameList = data;
        let subjectNameList = [];  
        let subjectIdList = [];  
        let msg1 = '';  
        let msg2 = '';  
        let msg3 = '';         
        for(let i = 0;i<this.records.length;i++){  
          this.records[i].voucher.details.forEach(val => {  
            let foundId = data.find(subject => subject.id === val.subjectId);  
            if(foundId && !foundId.leaf){  
              let subjectName = `${foundId.code}-${foundId.name}`;  
              // let subjectName = `${foundId.name}`; 
              if (!subjectNameList.includes(subjectName)) {  
                msg1 += subjectName + '，';  
                subjectNameList.push(subjectName);  
                subjectIdList.push(foundId.id);
              }  
            }  
              
            if(foundId && foundId.currencyAccounting.length > 0 && !val.exchangeRate && !val.amountFor){  
              let subjectName = `${foundId.code}-${foundId.name}`; 
              // let subjectName = `${foundId.name}`;  
              if (!subjectNameList.includes(subjectName)) {  
                msg2 += subjectName + '，';  
                subjectNameList.push(subjectName);  
                subjectIdList.push(foundId.id);
              }  
            }  
              
            if(foundId && foundId.auxiliaryAccounting.length > 0 && (!val.auxiliary || foundId.auxiliaryAccounting.length !== val.auxiliary.length)){  //9985  
              let subjectName = `${foundId.code}-${foundId.name}`; 
              // let subjectName = `${foundId.name}`; 
              if (!subjectNameList.includes(subjectName)) {  
                msg3 += subjectName + '，';  
                subjectNameList.push(subjectName);  
                subjectIdList.push(foundId.id);
              }  
            }  
          });  
        }  
        // 去除最后一个逗号，并添加提示信息  
        // 去除最后一个逗号，并添加提示信息  
        // else{this.hint1，使已经没问题的，置空
        if(msg1.length){  
          msg1 = msg1.slice(0, -1) + '，不是明细科目，请重新设置凭证模板或手动修改科目!';  
          this.hint1 = msg1;  
        }else{
          this.hint1 = '';
        }  
        if(msg2.length){  
          msg2 = msg2.slice(0, -1) + '，是外币核算科目，请手动填写汇率!';  
          this.hint2 = msg2;  
        } else{
          this.hint2 = '';
        }  
        if(msg3.length){  
          msg3 = msg3.slice(0, -1) + '，是辅助核算科目，请手动选择核算的项目!';  
          this.hint3 = msg3;  
        }  else{
          this.hint3 = '';
        }  
        this.msgSubjectNameList = subjectNameList;
        this.msgSubjectIdList = subjectIdList;
      })
    },
    //jxd移除
    removeRow(index){
      if(this.records.length > 1){
        this.records.splice(index, 1); // 移除当前元素  
        this.$forceUpdate(); // 强制更新视图
      }else{
        this.$Message({
          type:'warn',
          text: `至少保留一条记录！`
        });
      }
    },
    doSubmit() {
      let flag = false;
      this.records.forEach(item =>{
        console.log(item)
        if(item.voucher.creditAmount.toFixed(2).toString() != item.voucher.debitAmount.toFixed(2).toString()){
          console.log(item.voucher.creditAmount.toString())
          console.log(item.voucher.debitAmount.toString())
          message.warn(`凭证${item.voucher.word}-${item.voucher.code}，借方与贷方金额不相等，请检查！`);
          flag = true;
          return;
        }
      })
      if(flag){
        return;
      }
      if (this.records.every(value => !!value.voucher)) {
        let flg = true;
        this.records.forEach(item =>{
          item.voucher.details.forEach(items =>{
            if(this.msgSubjectIdList.includes(items.subjectId)){
              flg = false
            }
          })
        })
        if(flg){
          this.loading = true;
          Invoice.generateVoucher(this.records.map(value => value.voucher)).then(() => {
            this.$emit('success')
          }).finally(() => this.loading = false);
        }else{
          message.warn("异常科目还没有修改完成，请按红字提示修改后再试！")
        }
      }
    },
    footerMt({data}) {
      const debitAmount = data.reduce((t, r) => t + (r.debitAmount || 0), 0)
      const creditAmount = data.reduce((t, r) => t + (r.creditAmount || 0), 0)

      return [["合计", this.dxMoney(debitAmount), this.numFormat(debitAmount), this.numFormat(creditAmount)]]
    }
  },
  created() {
    let codeMap = {};
    let _this = this;
    InvoiceBusiness.list(this.type).then(async ({data}) => {
      if (data) {
        data.forEach(it => {
          this.templateMap[it.id] = it;
        })
        for (const row of this.records) {
          const template = _this.templateMap[row.invoiceBusinessTypeId];

          if (template && template.items && template.items.length) {
            let lastCode = codeMap[template.word];
            //1按发票日期 2按当前账期
            let date = _this.dateModel == "a1" ? row.tradeDate : _this.accountDate;
            if (!lastCode) {
              const results = await voucher.loadCode({word: template.word, currentAccountDate: date})
              codeMap[template.word] = results.data;
              lastCode = results.data;
            }
            const rows = [];
            let debitAmount = 0, creditAmount = 0;
            const voucherData = {word: template.word, code: lastCode, voucherDate: date};
            template.items.forEach(it => { 
              const item = {
                summary: `${row.businessType}_${row.category}_${row.invoiceNumber || ''}_${row.customerName || ''}`,
                subjectName: it.subjectTitle,
                subjectId: it.subjectId,
                currencyId: this.localCurrency.id,
              };
              if (it.direction === '借') {
                item.debitAmount = row[it.valueField];
                debitAmount += row[it.valueField];
              } else {
                item.creditAmount = row[it.valueField];
                creditAmount += row[it.valueField];
              }
              rows.push(item)
            })
            voucherData.invoiceId = row.id;
            voucherData.debitAmount = debitAmount;
            voucherData.creditAmount = creditAmount;
            voucherData.details = rows;
            row.voucher = voucherData;
            codeMap[template.word] = lastCode + 1;
          }
        }
        //jxd在这执行科目检测
        this.checkSubject();
        //加载辅助核算9985
        this.loadAccountingCategory()
      }
    })
  }
}
</script>
<style scoped>
.point-jxd{
  cursor: pointer;  
}
</style>